<template>
  <el-dialog
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    :show-cancel-button="false"
    :fullscreen="true"
    :close-on-press-escape="false"
    :show-close="true"
    @close="close"
  >
    <audio ref="audioPlayer" src="@/assets/audio.mp3" controls style="display: none" />
    <audio ref="successAudioPlayer" src="@/assets/success.mp3" controls style="display: none" />
    <el-form ref="form" :inline="true" :model="queryForm" @submit.native.prevent>
      <el-form-item v-if="tag == 0">
        <el-input
          v-if="pipei"
          ref="containerCode"
          v-model.trim="queryForm.containerCode"
          clearable
          :placeholder="$t('langs.Sorting_box_code')"
          @keyup.enter.native="locationEnter"
        />
      </el-form-item>

      <el-form-item v-else>
        <el-input
          v-if="fenjian"
          ref="itemNo"
          v-model.trim="queryForm.itemNo"
          clearable
          :placeholder="$t('commodityCode')"
          @keyup.enter.native="itemNoClick"
        />
        <el-input
          v-else
          ref="carNumber"
          v-model.trim="queryForm.carNumber"
          :placeholder="$t('langs.Container_code_sorting_box')"
          @keyup.enter.native="carNumberEnter"
        />
      </el-form-item>

      <el-form-item>
        <span class="setting-label">{{ $t('display_per_row') }}:</span>
        <el-select v-model="itemsPerRow" size="small" style="width: 150px; height: 50px" value-key="id" @change="itemPerRow">
          <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item" />
        </el-select>
      </el-form-item>

      <el-form-item>
        <div style="font-size:40px;font-weight: bold;margin-left: 20px;">{{$t('taskCode')}}：{{taskCode}}</div>
      </el-form-item>



      <el-button v-if="buttonShow" style="position: absolute; right: 5%" type="danger" plain @click="clearTaskCodeCache()">
        {{ $t('clearTaskCodeCache') }}
      </el-button>
    </el-form>

    <!-- 使用计算属性动态设置宽度 -->
    <div class="sortGoodBigBox">
      <div v-for="(item, index) in tableData" :key="index" class="sortGoodBox" :style="{ width: boxWidth, height: boxHeight }">
        <div
          v-if="item.orderStatus == 4"
          :class="{
            sortGoodItemsCopy: isActiveNew,
            sortGoodItems: isActive,
            fiveBox: isActivefive
          }"
          class="flip-card"
        >

          <div class="boxCarNumber">
            <span v-if="item.carNumber">{{ item.carNumber }}</span>
            <span v-else style="color: red">{{ $t('langs.not_bound') }}</span>
          </div>
          <div class="boxContainerCode">{{ $t('langs.Container_code_sorting_box') }}-{{ item.containerCode }}</div>
          <div class="boxPickTaskNum">{{ $t('langs.Selected_quantity') }}：{{ item.pickTaskNum }}/ {{ item.itemQty }}</div>
          <!-- <div class="itemNo">{{item.orderItems}}</div> -->
          <div class="guaqi" @click="hangUp(item.id)">{{ $t('langs.hang_up') }}</div>
        </div>


        <!-- 分货中状态 -->
        <div
          v-if="item.orderStatus == 5"
          :class="{
            sortGoodItems1New: isActiveNew,
            sortGoodItems1: isActive,
            fiveBox1: isActivefive
          }"
        >
          <div class="boxCarNumber">{{ item.carNumber }}</div>
          <div class="boxContainerCode">{{ $t('langs.Container_code_sorting_box') }}-{{ item.containerCode }}</div>
          <div class="boxPickTaskNum">{{ $t('langs.Selected_quantity') }}：{{ item.pickTaskNum }}/ {{ item.itemQty }}</div>
          <div class="guaqi" @click="hangUp(item.id)">{{ $t('langs.hang_up') }}</div>
        </div>
        <!-- 分货成功状态 -->
        <div
          v-if="item.orderStatus == 6"
          :class="{
            sortGoodItems2New: isActiveNew,
            sortGoodItems2: isActive,
            fiveBox2: isActivefive
          }"
        >
          <div class="boxCarNumber">{{ item.carNumber }}</div>
          <div class="boxContainerCode">{{ $t('langs.Container_code_sorting_box') }}-{{ item.containerCode }}</div>
          <div class="boxPickTaskNum">{{ $t('langs.Selected_quantity') }}：{{ item.pickTaskNum }}/ {{ item.itemQty }}</div>
          <div class="guaqi">{{ $t('completed') }}</div>
        </div>
        <!-- 挂起状态 -->
        <div
          v-if="item.orderStatus == 7"
          :class="{
            sortGoodItems4New: isActiveNew,
            sortGoodItems4: isActive,
            fiveBox4: isActivefive
          }"
        >
          <div class="boxCarNumber">{{ item.carNumber }}</div>
          <div class="boxContainerCode">{{ $t('langs.Container_code_sorting_box') }}-{{ item.containerCode }}</div>
          <div class="boxPickTaskNum">{{ $t('langs.Selected_quantity') }}：{{ item.pickTaskNum }}/ {{ item.itemQty }}</div>
          <div class="guaqi">{{ $t('langs.suspended') }}</div>
        </div>
        <!-- 分货提醒状态 -->
        <div
          v-if="item.orderStatus == 10"
          :class="{
            elementNew: isActiveNew,
            element: isActive,
            fiveBoxElementNew: isActivefive
          }"
        >
          <div class="boxCarNumber">{{ item.carNumber }}</div>
          <div class="boxContainerCode">{{ $t('langs.Container_code_sorting_box') }}-{{ item.containerCode }}</div>
          <div class="boxPickTaskNum">{{ $t('langs.Selected_quantity') }}：{{ item.pickTaskNum }}/ {{ item.itemQty }}</div>
          <div class="guaqi" @click="hangUp(item.id)">{{ $t('langs.hang_up') }}</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { searchPickTaskToCarNum, getB2cOrderListByCar, bindLocation, getLocationByItemNo, suspendedOrder, verifyContainerCode } from '@/api/xgcApi'
import store from '@/store'

export default {
  name: 'BoxBinding',
  data() {
    return {
      userInfo: store.getters.userInfo.dataPerms,
      dialogFormVisible: false,
      showCloseButton: false,
      listLoading: false,
      innerVisible: false,
      pipei: true,
      fenjian: true,
      tableData: [],
      innerTableData: [],
      options: [
        { id: 1, name: '2*10', code: '2', height: '10', layout: 'compact' },
        { id: 2, name: '3*7', code: '3', height: '7', layout: 'compact' },
        { id: 3, name: '4*5', code: '4', height: '5', layout: 'common' },
        { id: 4, name: '5*4', code: '5', height: '4', layout: 'standard' },
        { id: 5, name: '6*4', code: '6', height: '4', layout: 'standard' },
        { id: 6, name: '4*3', code: '4', height: '3', layout: 'standard' }
      ],
      // 新增：每行显示的项目数
      itemsPerRow: { id: 3, name: '4*5', code: '4', layout: 'standard' }, // 默认每行显示4个
      queryForm: {
        id: '',
        code: '',
        page: 1,
        limit: 10,
        itemNo: '',
        itemNo1: '',
        positionNo: '',
        pickingTaskId: '',
        containerCode: '',
        carNumber: '',
        appointmentStorageId: ''
      },
      isActive: true,
      isActiveNew: false,
      isActivefive: false,
      tag: 0,
      buttonShow: false,
      form: {},
      taskCode:'',
      formRules: {
        containerCode: [
          {
            required: true,
            message: this.$t('langs.Please_enter_container_number'),
            trigger: 'blur'
          }
        ],
        positionNo: [
          {
            required: true,
            message: this.$t('Please_select_location'),
            trigger: 'blur'
          }
        ],
        itemNo: [
          {
            required: true,
            message: this.$t('langs.Enter'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    // 计算每个盒子的宽度
    boxWidth() {
      // 计算百分比宽度，留出一些间距
      const percentage = 100 / this.itemsPerRow.code
      // 减去边距，这里假设每个盒子有10px的右边距
      const margin = 2 // 百分比边距
      return `calc(${percentage}% - ${margin}%)`
    },
    boxHeight() {
      const rows = this.itemsPerRow.height ? Number(this.itemsPerRow.height) : 5
      const vhPerItem = 100 / rows

      // console.log(this.itemsPerRow.height,'666666')
      // console.log(rows,'rows')
      //      console.log(vhPerItem,'vhPerItem')

      if (this.itemsPerRow.height == 3) {
        return `calc(${vhPerItem}vh - 8vh)`
      } else {
        return `calc(${vhPerItem}vh - 3vh)`
      }

      // 减去的值可以根据需要调整
    }
  },
  created() {
    // 尝试从localStorage加载之前的设置
    const savedItemsPerRow = localStorage.getItem('itemsPerRow')
    if (savedItemsPerRow) {
      const itemPerRowObj = JSON.parse(savedItemsPerRow)
      this.itemsPerRow = itemPerRowObj
      this.isActiveNew = this.itemsPerRow.layout == 'compact'
      this.isActivefive = this.itemsPerRow.layout == 'common'
      this.isActive = this.itemsPerRow.layout == 'standard'
    } else {
      this.isActiveNew = false
      this.isActivefive = true
      this.isActive = false
    }
  },
  methods: {
    showEdit(row) {
      this.queryForm.code = row
      this.dialogFormVisible = true
      this.getTableDataList(row)
      this.$nextTick(() => {
        const input = this.$refs.containerCode
        input.focus()
      })
      if (this.userInfo == '平台权限') {
        this.buttonShow = true
      } else {
        this.buttonShow = false
      }
    },
    itemPerRow(value) {
      this.isActiveNew = value.layout === 'compact'
      this.isActivefive = value.layout === 'common'
      this.isActive = value.layout === 'standard'

      this.saveDisplaySetting()
    },
    getTableDataList(code) {
      this.listLoading = true
      getB2cOrderListByCar(code)
        .then((res) => {
          this.tag = res.tag
          this.tableData = res.data
          if (res.data && res.data.length > 0) {
            this.queryForm.pickingTaskId = res.data[0].pickingTaskId
          }
          localStorage.setItem('containerCode', code)
          if (res.finishTag == 2) {
            this.$message({
              message: this.$t('langs.All_goods_successfully'),
              type: 'success'
            })
            window.localStorage.removeItem('containerCode')
            setTimeout(() => {
              this.$emit('fetch-data')
              this.dialogFormVisible = false
            }, 3000)
          }
          const containerCode = localStorage.getItem('containerCode')
          if (containerCode) {
            this.taskCode = containerCode
          }
        })
        .catch(() => {
          setTimeout(() => {
            this.$emit('fetch-data')
            this.dialogFormVisible = false
          }, 1000)
        })
      setTimeout(() => {
        this.listLoading = false
      }, 300)
    },

    // 当itemsPerRow改变时保存设置
    saveDisplaySetting() {
      localStorage.setItem('itemsPerRow', JSON.stringify(this.itemsPerRow))
    },

    playAudio() {
      this.$refs.audioPlayer.play()
    },

    playSuccessAudio() {
      this.$refs.successAudioPlayer.play()
    },

    containerCodeClick() {
      this.pipei = false
      this.$message({
        message: this.$t('langs.scanning_orting_box_code_successful'),
        type: 'success'
      })
    },

    itemNoClick() {
      this.fenjian = false
      const data = {
        itemNo: this.queryForm.itemNo,
        id: this.queryForm.pickingTaskId
      }
      getLocationByItemNo(data)
        .then((res) => {
          this.$message({
            message: this.$t('langs.product_code_scan_successful'),
            type: 'success'
          })
          this.tag = res.tag
          this.tableData = res.data
          this.playSuccessAudio()
          this.$nextTick(() => {
            const input = this.$refs.carNumber
            input.focus()
          })
        })
        .catch(() => {
          this.fenjian = true
          this.queryForm.itemNo = ''
          this.playAudio()
        })

      localStorage.setItem('fenjian', this.fenjian)
    },

    carNumberEnter() {
      const data = {
        itemNo: this.queryForm.itemNo,
        id: this.queryForm.pickingTaskId,
        containerCode: this.queryForm.carNumber
      }
      verifyContainerCode(data)
        .then((res) => {
          this.fenjian = true
          this.queryForm.itemNo = ''
          this.queryForm.carNumber = ''
          this.tag = res.tag
          this.tableData = res.data
          this.playSuccessAudio()
          // this.speakWithThrottle('成功')
          this.$message({
            message: this.$t('langs.Location_scan_successful'),
            type: 'success'
          })
          if (res.finishTag == 2) {
            this.speakWithThrottle('分货全部成功，3秒后关闭')
            this.$message({
              message: this.$t('langs.All_goods_successfully'),
              type: 'success'
            })
            window.localStorage.removeItem('containerCode')
            this.playSuccessAudio()
            setTimeout(() => {
              this.$emit('fetch-data')
              this.dialogFormVisible = false
            }, 3000)
          }
        })
        .catch(() => {
          this.playAudio()
          this.queryForm.carNumber = ''
          const input = this.$refs.carNumber
          input.focus()
        })
    },

    locationEnter() {
      const data = {
        taskCode: this.queryForm.code,
        containerCode: this.queryForm.containerCode,
        id: this.queryForm.pickingTaskId
      }
      bindLocation(data)
        .then((res) => {
          this.playSuccessAudio()
          this.pipei = true
          this.queryForm.containerCode = ''
          this.queryForm.carNumber = ''
          this.speakWithThrottle('成功')
          this.$message({
            message: this.$t('langs.binding_sorting_box_successful'),
            type: 'success'
          })
          this.getTableDataList(this.queryForm.code)
        })
        .catch(() => {
          this.pipei = true
          this.queryForm.containerCode = ''
          this.queryForm.carNumber = ''
          this.speakWithThrottle('请检查')
          this.playAudio()
          const input = this.$refs.containerCode
          input.focus()
        })
    },
// 清除任务码缓存
    clearTaskCodeCache() {
      this.$confirm('清除任务码缓存', this.$t('hint'), {
        confirmButtonText: this.$t('public.determine'),
        cancelButtonText: this.$t('public.cancellation'),
        type: 'warning'
      })
        .then(() => {
          localStorage.removeItem('containerCode')
          localStorage.removeItem('itemsPerRow')
          this.$message.success('清除成功')
          this.dialogFormVisible = false
          this.$emit('fetch-data')
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.Canceled')
          })
        })
    },
// 挂起订单
    hangUp(orderId) {
      this.$prompt(this.$t('langs.specify_reason_suspension'), this.$t('hint'), {
        confirmButtonText: this.$t('public.determine'),
        cancelButtonText: this.$t('public.cancellation'),
        inputPlaceholder: this.$t('langs.please_enter_reason')
      })
        .then(({ value }) => {
          if (!value || value.trim() === '') {
            this.$message.warning(this.$t('langs.reason_cannot_be_empty'))
            return
          }
          const data = {
            orderId: orderId,
            reason: value.trim()
          }
          suspendedOrder(data)
            .then((res) => {
              const index = this.tableData.findIndex((item) => item.id === orderId)
              if (index !== -1) {
                this.$set(this.tableData, index, {
                  ...this.tableData[index],
                  orderStatus: 7
                })
              }
              this.$message({
                type: 'success',
                message: this.$t('langs.suspension_successful')
              })

              if (res.finishTag == 2) {
                this.$message({
                  message: this.$t('langs.All_goods_successfully'),
                  type: 'success'
                })
                window.localStorage.removeItem('containerCode')
                setTimeout(() => {
                  this.$emit('fetch-data')
                  this.dialogFormVisible = false
                }, 3000)
              }
            })
            .catch((err) => {
              console.error('挂起失败:', err)
              this.playAudio()
              this.$message.error(this.$t('langs.suspension_failed'))
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.Canceled')
          })
        })
    },

    handleSizeChange(val) {
      this.queryForm.limit = val
      this.getTableDataList()
    },

    handleCurrentChange(val) {
      this.queryForm.page = val
      this.getTableDataList()
    },

    handleDelete(row) {
      this.$confirm(this.$t('dele'), this.$t('hint'), {
        confirmButtonText: this.$t('public.determine'),
        cancelButtonText: this.$t('public.cancellation'),
        type: 'warning'
      })
        .then(() => {
          const index = this.tableData.indexOf(row)
          if (index !== -1) {
            this.tableData.splice(index, 1)
          }
          this.form.details = this.tableData
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.Canceled')
          })
        })
    },

    close() {
      // 保存显示设置
      this.saveDisplaySetting()
      this.dialogFormVisible = false
    },

    handleQueryItemNo() {
      searchPickTaskToCarNum(this.queryForm).then((res) => {
        this.innerTableData = res.data.pickTaskInterimVos
      })
    },

    startPick(e) {
      this.innerVisible = true
      this.queryForm.itemNo1 = e
      searchPickTaskToCarNum(this.queryForm).then((res) => {
        this.innerTableData = res.data.pickTaskInterimVos
      })
      this.$nextTick(() => {
        const input = this.$refs.positionNo
        input.focus()
      })
    },
    // 带节流的语音播报（避免连续扫码时播报重叠）
    speakWithThrottle(text) {
      const now = Date.now()
      // 500ms 内只播报一次
      if (now - this.lastSpeakTime < 500) {
        return
      }
      this.lastSpeakTime = now
      this.speak(text)
    },
    // 语音播报方法
    speak(text) {
      if (!window.speechSynthesis) {
        console.warn('当前浏览器不支持语音播报')
        return
      }

      try {
        // 取消正在进行的播报
        window.speechSynthesis.cancel()
        const utterance = new SpeechSynthesisUtterance(text)
        utterance.lang = 'zh-CN'
        utterance.rate = 1.2 // 语速正常（正常为1，0.85略慢于正常语速）
        utterance.pitch = 1

        // 监听错误
        utterance.onerror = (event) => {
          console.error('语音播报失败:', event)
        }

        window.speechSynthesis.speak(utterance)
      } catch (error) {
        console.error('语音播报异常:', error)
      }
    }
  }
}
</script>

<style langs="scss" scoped>
::v-deep .el-dialog__header {
  margin: 0;
  padding: 0;
}

::v-deep .el-dialog__headerbtn {
  display: none;
}

::v-deep .el-input--small .el-input__inner {
  height: 50px;
  line-height: 50px;
  font-size: 30px;
}
/* 新增：显示设置样式 */
.display-settings {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.setting-label {
  margin-right: 10px;
  font-weight: bold;
  color: #606266;
}

.item_box {
  border: 1px solid #999;
  border-radius: 10px;
  padding: 16px;
  box-sizing: border-box;
  margin-bottom: 16px;
}

.warning-row {
  background: oldlace;
}

/* 关键帧动画 */
@keyframes flashBackground {
  0% {
    background-color: #f3f6fb;
  }
  25% {
    background-color: #55ff00;
  }
  50% {
    background-color: #00aaff;
  }
  75% {
    background-color: #ffaa00;
  }
  100% {
    background-color: #c5dbff;
  }
}

.element {
  animation: flashBackground 0.5s infinite;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background: #f3f6fb;
  padding: 16px;
  box-sizing: border-box;
}

.elementNew {
  animation: flashBackground 0.5s infinite;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  box-sizing: border-box;
  background: #f3f6fb;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .boxCarNumber {
    font-size: 35px;
    color: #000;
    font-weight: bold;
  }
  .boxContainerCode {
    color: #000;
    font-size: 20px;
    margin: 0;
  }
  .boxPickTaskNum {
    color: #000;
    font-size: 20px;
    margin: 0;
  }
  .guaqi {
    width: 10%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
  }
}

.sortGoodBigBox {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

/* 修改盒子样式，使用动态宽度 */
.sortGoodBox {
  /* height: 200px; */
  margin: 0px 10px 10px 0px;
  /* 宽度由计算属性动态设置 */
}

.sortGoodItems {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 16px;
  box-sizing: border-box;
  background: #dfe4ed;
}

.sortGoodItemsCopy {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  box-sizing: border-box;
  background: #dfe4ed;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .boxCarNumber {
    font-size: 35px;
    color: #000;
    font-weight: bold;
  }
  .boxContainerCode {
    color: #000;
    font-size: 20px;
    margin: 0;
  }
  .boxPickTaskNum {
    color: #000;
    font-size: 20px;
    margin: 0;
  }
  .guaqi {
    width: 10%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
  }
}

.sortGoodItems1 {
  width: 100%;
  height: 100%;
  background-color: #ffff00;
  border-radius: 20px;
  padding: 16px;
  box-sizing: border-box;
}

.sortGoodItems1New {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  box-sizing: border-box;
  background-color: #ffff00;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .boxCarNumber {
    font-size: 35px;
    color: #000;
    font-weight: bold;
  }
  .boxContainerCode {
    color: #000;
    font-size: 20px;
    margin: 0;
  }
  .boxPickTaskNum {
    color: #000;
    font-size: 20px;
    margin: 0;
  }
  .guaqi {
    width: 10%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
  }
}

.sortGoodItems2 {
  width: 100%;
  height: 100%;
  background: #2c8400;
  border-radius: 20px;
  padding: 16px;
  box-sizing: border-box;
}
.sortGoodItems2New {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  box-sizing: border-box;
  background: #2c8400;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .boxCarNumber {
    font-size: 35px;
    color: #000;
    font-weight: bold;
  }
  .boxContainerCode {
    color: #000;
    font-size: 20px;
    margin: 0;
  }
  .boxPickTaskNum {
    color: #000;
    font-size: 20px;
    margin: 0;
  }
  .guaqi {
    width: 10%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
  }
}
.sortGoodItems4 {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 16px;
  box-sizing: border-box;
  background: #fb735a;
}
.sortGoodItems4New {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  box-sizing: border-box;
  background: #fb735a;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .boxCarNumber {
    font-size: 35px;
    color: #000;
    font-weight: bold;
  }
  .boxContainerCode {
    color: #000;
    font-size: 20px;
    margin: 0;
  }
  .boxPickTaskNum {
    color: #000;
    font-size: 20px;
    margin: 0;
  }
  .guaqi {
    width: 10%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
  }
}
.boxCarNumber {
  font-size: 35px;
  color: #000;
  font-weight: bold;
  margin-bottom: 10px;
}

.boxContainerCode {
  color: #000;
  font-size: 19px;
  margin-bottom: 10px;
}

.boxPickTaskNum {
  color: #000;
  font-size: 20px;
  margin-bottom: 10px;
}
.guaqi {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
}

::v-deep .el-input--medium .el-input__inner {
  height: 50px !important;
  line-height: 50px !important;
}

::v-deep .el-form-item--medium .el-form-item__label {
  line-height: 50px;
  font-size: 20px;
}

.fiveBox {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #dfe4ed;
  .boxCarNumber {
    font-size: 30px;
    color: #000;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .boxContainerCode {
    color: #000;
    font-size: 19px;
    margin-bottom: 5px;
  }
  .boxPickTaskNum {
    color: #000;
    font-size: 19px;
    margin-bottom: 8px;
  }
  .guaqi {
    width: 100%;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px;
  }
}

.fiveBox1 {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #ffff00;
  .boxCarNumber {
    font-size: 30px;
    color: #000;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .boxContainerCode {
    color: #000;
    font-size: 19px;
    margin-bottom: 5px;
  }
  .boxPickTaskNum {
    color: #000;
    font-size: 19px;
    margin-bottom: 8px;
  }
  .guaqi {
    width: 100%;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px;
  }
}

.fiveBox2 {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #2c8400;
  .boxCarNumber {
    font-size: 30px;
    color: #000;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .boxContainerCode {
    color: #000;
    font-size: 19px;
    margin-bottom: 5px;
  }
  .boxPickTaskNum {
    color: #000;
    font-size: 19px;
    margin-bottom: 8px;
  }

  .guaqi {
    width: 100%;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px;
  }
}

.fiveBox4 {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #fb735a;
  .boxCarNumber {
    font-size: 30px;
    color: #000;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .boxContainerCode {
    color: #000;
    font-size: 19px;
    margin-bottom: 5px;
  }
  .boxPickTaskNum {
    color: #000;
    font-size: 19px;
    margin-bottom: 8px;
  }
  .guaqi {
    width: 100%;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px;
  }
}

.fiveBoxElementNew {
  animation: flashBackground 0.5s infinite;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #f3f6fb;
  .boxCarNumber {
    font-size: 30px;
    color: #000;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .boxContainerCode {
    color: #000;
    font-size: 19px;
    margin-bottom: 5px;
  }
  .boxPickTaskNum {
    color: #000;
    font-size: 19px;
    margin-bottom: 8px;
  }
  .guaqi {
    width: 100%;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px;
  }
}
  .itemNo{
    color: #000;
    font-size: 18px;
    margin-bottom: 10px;
  }

</style>
